import { render } from "./PackageComponent.vue?vue&type=template&id=f0687b40&scoped=true"
import script from "./PackageComponent.vue?vue&type=script&lang=js"
export * from "./PackageComponent.vue?vue&type=script&lang=js"

import "./PackageComponent.vue?vue&type=style&index=0&id=f0687b40&scoped=true&lang=css"

import exportComponent from "/home/n3rdy/dev/virtuallab-networksecurity/exp-5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0687b40"]])

export default __exports__